module.exports = __webpack_public_path__ + "img/454.57b31678.jpg";